export default {
	"a1016e95e32bb52f09c8f1d28c2ed6d1": "商品已售罄，請重新選擇兑換商品",
	"dd7c1a8f6562b64472dc9f43e2219abb": "我知道了"
}
